export default __webpack_public_path__ + "static/media/dbatuLogo.ccf40e33.png";